// import React, { useContext, useEffect, useState } from "react";
// import { FiEdit } from "react-icons/fi";
// import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";
// import formateText from "../../../utils/Formate";
// import { MdPreview } from "react-icons/md";
// import { MdOutlineArrowForwardIos } from "react-icons/md";
// import { MdOutlineArrowBackIosNew } from "react-icons/md";

// const HistoryTable = ({
//   headers,
//   fetchedData,
//   clearActiveRow,
//   row,
//   editCallBack,
//   notEditAble,
//   noSearch,
//   extraFields,
//   notSearchAble,
//   small,
//   onSelectCallBack,
// }) => {
//   const {
//     companys,
//     isAllDataFetched,
//     branchs,
//     measurementUnits,
//     devices,
//     cargoTypes,
//     routes,
//     functions,
//     agent,
//     boxName,
//     measurementUnit,
//     device,
//     scanningPoint,
//     scanningPerson,
//     parcelStatus,
//     allUser,
//     onSelect,
//   } = useContext(contextProvider);

//   // main array of object.
//   const [data, setData] = useState(null);

//   // set array of object data.
//   useEffect(() => {
//     if (fetchedData) setData(fetchedData);
//   }, [fetchedData]);

//   const typeValidation = (field, fetchedObject) => {
//     if (
//       !fetchedObject[field] &&
//       field !== "boxAssignPreviousMonth" &&
//       field !== "limitCurrentMonth" &&
//       field !== "boxAssignCurrentMonth" &&
//       field !== "limitPreviousMonth" &&
//       field !== "isAgent" &&
//       field !== "boxQty" &&
//       field !== "isHub" &&
//       field !== "isOffice" &&
//       field !== "isActive" &&
//       field !== "isExpressService" &&
//       field !== "receiveQty" &&
//       field !== "adjustmentQty" &&
//       field !== "Route Cost" &&
//       field !== "Dimension Cost" && //
//       field !== "Weight Cost" &&
//       field !== "Item Type Cost" &&
//       field !== "Additional Cost" &&
//       field !== "Cargo Type Cost" &&
//       field !== "Extra Packaging Cost" &&
//       field !== "Pickup Cost" &&
//       field !== "Total" && //
//       field !== "issueQty"
//     ) {
//       return <span className="text-red-400">Not Available</span>;
//     }

//     if (field === "isActive" && fetchedObject[field] === true) return "Active";
//     if (field === "isActive" && fetchedObject[field] === false)
//       return "Inactive";

//     if (
//       (field === "isExpressService" ||
//         field === "isHub" ||
//         field === "isOffice" ||
//         field === "isAgent") &&
//       fetchedObject[field] === true
//     )
//       return "Yes";
//     if (
//       (field === "isExpressService" ||
//         field === "isHub" ||
//         field === "isOffice" ||
//         field === "isAgent") &&
//       fetchedObject[field] === false
//     )
//       return "No";

//     if (field === "parcelStatusId") {
//       let data = parcelStatus?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.parcelStatusName;

//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "scanningPersonId") {
//       let data = scanningPerson?.find(
//         (item) => item.userId === fetchedObject[field]
//       )?.userName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "scanningPointId") {
//       let data = scanningPoint?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.scanningPointName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "measurementUnitId") {
//       let data = measurementUnit?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.unitDescription;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "deviceId") {
//       let data = device?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.deviceName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "dimensionId") {
//       let data = boxName?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.dimensionName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "agentId" || field === "transportAgentId") {
//       let data = agent?.find((item) => item.id === fetchedObject[field])?.name;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "companyId") {
//       let data = companys?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.name;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "routeId") {
//       let data = routes?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.routeName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "cargoId") {
//       let data = cargoTypes?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.cargoTypeName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "MeasurementUnitId") {
//       // need to update.
//       let data = measurementUnits?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.cargoTypeName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "issuedBy") {
//       // need to update.
//       let data = allUser?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.roleName;

//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (
//       field === "startDate" ||
//       field === "paymentDate" ||
//       field === "issueDate" ||
//       field === "transactionDate"
//     ) {
//       const date = new Date(fetchedObject[field]);

//       let data = `${date.getDate()}/${
//         date.getMonth() + 1
//       }/${date.getFullYear()}`;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "endDate") {
//       const date = new Date(fetchedObject[field]);
//       let data = `${date.getDate()}/${
//         date.getMonth() + 1
//       }/${date.getFullYear()}`;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "discountedDate") {
//       const date = new Date(fetchedObject[field]);
//       let data = `${date.getDate()}/${
//         date.getMonth() + 1
//       }/${date.getFullYear()}`;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }

//     return fetchedObject[field];
//   };

//   const [activeRow, setActiveRow] = useState(null);

//   useEffect(() => {
//     if (clearActiveRow) setActiveRow(null);
//   }, [clearActiveRow]);

//   useEffect(() => {
//     setActiveRow(null);
//   }, [fetchedData]);

//   // pageination logics. every page have 10 row.

//   // per page data limit.
//   const limit = 10;

//   // get array of pagination page number.
//   const getbuttonNumbersArray = (start, end) => {
//     const numbersArray = [];
//     for (let i = start; i <= end; i++) {
//       numbersArray.push(i);
//     }
//     return numbersArray;
//   };

//   // split data.
//   const splitData = (pageNo) => {
//     const startingIndex = (pageNo - 1) * limit;
//     const endingIndex = pageNo * limit;
//     const splitedData = fetchedData?.slice(startingIndex, endingIndex);
//     setData(splitedData);
//   };

//   // call array spliting function.
//   const [pageNo, setPageNo] = useState(1);

//   useEffect(() => {
//     splitData(pageNo);
//   }, [pageNo, fetchedData]);

//   const totalPaginationPage = Math.ceil(fetchedData?.length / limit);
//   const [PaginationButtonNumbers, setPaginationButtonNumbers] = useState([]);

//   const [reArange, setRearange] = useState(false);
//   useEffect(() => {
//     if (totalPaginationPage < 4)
//       return setPaginationButtonNumbers(
//         getbuttonNumbersArray(1, totalPaginationPage)
//       );
//     return setPaginationButtonNumbers(getbuttonNumbersArray(1, 4));
//   }, [fetchedData, reArange]);

//   const skipPaginationNumber = (start, end) => {
//     setPaginationButtonNumbers(getbuttonNumbersArray(start, end));
//   };

//   // modal controll.
//   const [showModal, setShowMOdal] = useState(null);
//   const [modalData, setModalData] = useState(null);

//   const TableSearchHandle = (e) => {
//     e.preventDefault();
//     const searchAbleText = e.target.searchText.value;
//     if (!fetchedData) return;

//     const isInclued = (values) => {
//       for (let item of values) {
//         if (item !== null && item !== undefined) {
//           const preferedItem = item.toString().toLowerCase();
//           const preferedSearchText = searchAbleText.toString().toLowerCase();
//           if (preferedItem.includes(preferedSearchText)) return true;
//         }
//       }
//       return false;
//     };

//     const filteredData = fetchedData.filter((item) => {
//       const itemValuesArray = Object.values(item);
//       return isInclued(itemValuesArray);
//     });

//     setData(filteredData);
//   };

//   // clear search .
//   const clearSearch = () => {
//     setData(fetchedData);
//     setSearchText("");
//   };

//   const [searchText, setSearchText] = useState("");

//   return (
//     <div className={small ? "scale-95 text-end" : "text-end"}>
//       {!notSearchAble && (
//         <form
//           onSubmit={TableSearchHandle}
//           className={
//             noSearch
//               ? "hidden"
//               : "xl:w-[30%] w-full  inline-flex items-center lg:gap-x-2 gap-x-1 justify-between lg:justify-end mb-4"
//           }
//         >
//           <input
//             onChange={(e) => setSearchText(e.target.value)}
//             value={searchText}
//             required
//             className="w-full lg:w-[30%] xl:w-full border-2 lg:border-[3px] pl-2  border-[#83430D] h-10 lg:h-12 outline-none rounded-lg bg-transparent"
//             type="text"
//             name="searchText"
//             placeholder="You text here"
//           />
//           <button
//             className={`font-medium  text-base lg:text-lg bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[8px] h-[40px] lg:h-[47px] px-4 lg:px-6  text-white`}
//           >
//             Search
//           </button>
//           <button
//             onClick={clearSearch}
//             type="button"
//             className={`font-medium  text-base lg:text-lg bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[8px] h-[40px] lg:h-[47px] px-4 lg:px-6  text-white`}
//           >
//             Clear
//           </button>
//         </form>
//       )}
//       <div className=" w-full  overflow-x-auto rounded-lg overflow-hidden bg-[#fceee5]">
//         <div className="">
//           <table className="w-full">
//             <thead className="">
//               <tr className="  w-full bg-[#f5cfb5] lg:text-lg text-sm text-center">
//                 {!notSearchAble && <th className="lg:py-4 py-3 px-4">S/N</th>}
//                 {headers?.map((item) => (
//                   <th
//                     key={item}
//                     className=" lg:py-4 py-3 px-4 text-base lg:text-lg  w-max"
//                   >
//                     <span className="w-max inline-block">
//                       {formateText(item)}
//                     </span>
//                   </th>
//                 ))}
//                 {!notSearchAble && (
//                   <th className={notEditAble ? "hidden" : "py-4 px-12"}></th>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {isAllDataFetched &&
//                 data?.map((item, index) => {
//                   // return tr.
//                   const fetchedObject = item;

//                   const editFuncData = {
//                     id: fetchedObject?.id,
//                     modificationDate: new Date(),
//                   };
//                   extraFields?.forEach(
//                     (field) => (editFuncData[field] = fetchedObject[field])
//                   );

//                   const td = row?.map((field, idx) => {
//                     editFuncData[field] = fetchedObject[field];

//                     return (
//                       <td
//                         key={idx}
//                         className="text-center text-sm lg:text-base font-normal lg:font-semibold lg:py-3 py-2 px-4 w-max hover:bg-gray-100 hover:text-blue-600 transition-colors duration-200"
//                         onClick={() => {
//                           if (onSelectCallBack) {
//                             onSelectCallBack(item);
//                           }
//                         }}
//                         style={{
//                           cursor: onSelectCallBack ? "pointer" : "default",
//                         }}
//                       >
//                         <span className="w-max inline-block">
//                           {typeValidation(field, fetchedObject)}
//                         </span>
//                       </td>
//                     );
//                   }); // return td.

//                   return (
//                     <tr
//                       key={index}
//                       className={
//                         activeRow === index
//                           ? "bg-[#ee9d67]"
//                           : index % 2 !== 0
//                           ? "bg-[#fce8db] "
//                           : "bg-[#fcf4ef]"
//                       }
//                     >
//                       {!notSearchAble && (
//                         <td className="text-center lg:py-3 py-2 font-normal lg:font-semibold">
//                           {(pageNo - 1) * limit + (index + 1)}
//                         </td>
//                       )}

//                       {td}
//                       <td className="flex justify-center items-center gap-2">
//                         <button
//                           className={
//                             notEditAble
//                               ? "hidden"
//                               : "text-center py-3 font-semibold flex justify-center items-center text-xl text-[#c26040]"
//                           }
//                           onClick={() => {
//                             editCallBack(editFuncData);
//                             setActiveRow(index);
//                           }}
//                         >
//                           <FiEdit />
//                         </button>

//                         <button
//                           className={
//                             notEditAble
//                               ? "hidden"
//                               : "text-center py-3 font-semibold flex justify-center items-center text-xl text-[#c26040]"
//                           }
//                           onClick={() => {
//                             // editCallBack(editFuncData);
//                             setActiveRow(index);
//                           }}
//                         >
//                           <MdPreview />
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div
//         className={
//           fetchedData?.length <= limit
//             ? "hidden"
//             : "flex items-center gap-x-1 m-auto justify-center mb-11 mt-4"
//         }
//       >
//         <button
//           onClick={() => {
//             if (
//               pageNo === PaginationButtonNumbers[0] &&
//               (pageNo < totalPaginationPage) & (pageNo > 1)
//             ) {
//               if (totalPaginationPage >= pageNo - 4 && pageNo - 4 >= 1)
//                 skipPaginationNumber(pageNo - 4, pageNo);
//               else if (1 > pageNo - 4) skipPaginationNumber(1, pageNo);
//             }
//             if (1 < pageNo) {
//               setPageNo((prev) => prev - 1);
//             }
//           }}
//           className={
//             "font-medium  text-base bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white"
//           }
//         >
//           <MdOutlineArrowBackIosNew className="lg:text-xl text-sm" />
//         </button>

//         <button
//           onClick={() => {
//             if ((pageNo <= totalPaginationPage) & (pageNo > 1)) {
//               if (totalPaginationPage >= pageNo - 4 && pageNo - 4 >= 1) {
//                 skipPaginationNumber(pageNo - 4, pageNo);
//                 setPageNo((prev) => prev - 4);
//               } else if (1 > pageNo - 4) {
//                 skipPaginationNumber(1, pageNo);
//                 setPageNo((prev) => prev - (pageNo - 1));
//               }
//             }
//           }}
//           className={
//             "font-medium  text-2xl  rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-black"
//           }
//         >
//           ...
//         </button>

//         {PaginationButtonNumbers?.map((item) => {
//           return (
//             <button
//               onClick={() => setPageNo(item)}
//               className={`font-medium  text-base bg-gradient-to-tr ${
//                 pageNo === item
//                   ? "from-[#b9b89b] to-[#b3b3ae]"
//                   : "from-[#6D4C41] to-[#424242]"
//               } rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white`}
//               key={item}
//             >
//               {item}
//             </button>
//           );
//         })}

//         <button
//           onClick={() => {
//             if (pageNo < totalPaginationPage) {
//               if (totalPaginationPage >= pageNo + 4) {
//                 skipPaginationNumber(pageNo, pageNo + 4);
//                 setPageNo((prev) => prev + 4);
//               } else if (totalPaginationPage < pageNo + 4) {
//                 skipPaginationNumber(pageNo, totalPaginationPage);
//                 setPageNo((prev) => prev + totalPaginationPage - pageNo);
//               }
//             }
//           }}
//           className={
//             "font-medium  text-2xl  rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-black"
//           }
//         >
//           ...
//         </button>
//         <button
//           onClick={() => {
//             if (
//               pageNo ===
//                 PaginationButtonNumbers[PaginationButtonNumbers.length - 1] &&
//               pageNo < totalPaginationPage
//             ) {
//               if (totalPaginationPage >= pageNo + 4)
//                 skipPaginationNumber(pageNo, pageNo + 4);
//               else if (totalPaginationPage < pageNo + 4)
//                 skipPaginationNumber(pageNo, totalPaginationPage);
//             }
//             if (totalPaginationPage > pageNo) {
//               setPageNo((prev) => prev + 1);
//             }
//           }}
//           className={
//             "font-medium  text-base bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[3px] px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white"
//           }
//         >
//           <MdOutlineArrowForwardIos className="lg:text-xl text-sm" />
//         </button>
//       </div>

//       {/* You can open the modal using document.getElementById('ID').showModal() method */}
//       {/* <button
//         className="btn"
//         onClick={() => document.getElementById("my_modal_3").showModal()}
//       >
//         open modal
//       </button> */}
//       <dialog id="my_modal_3" className="modal">
//         <div className="modal-box">
//           <form method="dialog">
//             {/* if there is a button in form, it will close the modal */}
//             <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
//               ✕
//             </button>
//           </form>
//           <h3 className="font-bold text-lg">Hello!</h3>
//           <p className="py-4">Press ESC key or click on ✕ button to close</p>
//         </div>
//       </dialog>
//     </div>
//   );
// };

// export default HistoryTable;



import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { usePermission } from "../../../context/PermissionContext";
import { screenCodeFromPath } from "../../../utils/permissionScreens";
import { FiChevronDown, FiEdit, FiDownload, FiPrinter } from "react-icons/fi";
import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";
import formateText from "../../../utils/Formate";
import { MdPreview } from "react-icons/md";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import axios from "axios";
import { formatCurrency } from "../../../utils/formatCurrency";

function paymentStatusTone(statusName, paymentStatusId) {
  const name = String(statusName || "").toLowerCase();
  const id = Number(paymentStatusId);
  if (id === 2 || name.includes("paid") || name.includes("complete")) {
    return {
      chip: "bg-emerald-100 text-emerald-800 border-emerald-200",
      bar: "border-l-emerald-500",
    };
  }
  if (id === 4 || name.includes("credit")) {
    return {
      chip: "bg-sky-100 text-sky-800 border-sky-200",
      bar: "border-l-sky-500",
    };
  }
  if (id === 1 || name.includes("pending") || name.includes("unpaid")) {
    return {
      chip: "bg-amber-100 text-amber-900 border-amber-200",
      bar: "border-l-amber-500",
    };
  }
  return {
    chip: "bg-stone-100 text-stone-700 border-stone-200",
    bar: "border-l-stone-400",
  };
}

function formatPaymentDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("en-GB");
}

function summarizeGroupStatuses(items = []) {
  const counts = {};
  items.forEach((p) => {
    const label = String(p?.statusName || "Unknown").trim() || "Unknown";
    counts[label] = (counts[label] || 0) + 1;
  });
  return Object.entries(counts)
    .map(([label, n]) => `${n} ${label}`)
    .join(" · ");
}

const HistoryTable = ({
  headers,
  fetchedData,
  clearActiveRow,
  row,
  editCallBack,
  notEditAble,
  noSearch,
  extraFields,
  notSearchAble,
  small,
  onSelectCallBack,
  showViewCost = false,
  /** When set (e.g. "parcelNoWithRecordSerialNo"), rows with the same key accordion together. */
  groupBy = null,
  /** Optional: open invoice print for a payment row (Payment History). */
  onPrintInvoice = null,
  /** Optional: open invoice download for a payment row (Payment History). */
  onDownloadInvoice = null,
  invoiceBusyKey = null,
}) => {
  const {
    companys,
    isAllDataFetched,
    branchs,
    measurementUnits,
    devices,
    cargoTypes,
    routes,
    functions,
    agent,
    boxName,
    dimensions,
    measurementUnit,
    device,
    scanningPoint,
    scanningPerson,
    parcelStatus,
    allUser,
    onSelect,
  } = useContext(contextProvider);
  const location = useLocation();
  const { canEdit } = usePermission();
  const permissionScreen = screenCodeFromPath(location.pathname);
  const hideEdit =
    notEditAble || (permissionScreen ? !canEdit(permissionScreen) : false);

  // State for table data
  const [data, setData] = useState(null);
  const [filteredRows, setFilteredRows] = useState(null);
  const [pageGroups, setPageGroups] = useState([]);
  const [expandedGroupKey, setExpandedGroupKey] = useState(null);
  const [activeRow, setActiveRow] = useState(null);

  // State for cost details modal
  const [showCostModal, setShowCostModal] = useState(false);
  const [parcelCostData, setParcelCostData] = useState(null);
  const [loadingCostData, setLoadingCostData] = useState(false);
  const [currentParcelNo, setCurrentParcelNo] = useState(null);

  // Pagination states
  const [pageNo, setPageNo] = useState(1);
  const [PaginationButtonNumbers, setPaginationButtonNumbers] = useState([]);
  const [reArange, setRearange] = useState(false);

  // Search state
  const [searchText, setSearchText] = useState("");
  const backendUrl = process.env.REACT_APP_API_URL;
  // Set array of object data
  useEffect(() => {
    if (fetchedData) {
      setData(fetchedData);
      setFilteredRows(fetchedData);
      setExpandedGroupKey(null);
    }
  }, [fetchedData]);

  // Clear active row when needed
  useEffect(() => {
    if (clearActiveRow) setActiveRow(null);
  }, [clearActiveRow]);

  useEffect(() => {
    setActiveRow(null);
    setExpandedGroupKey(null);
  }, [fetchedData]);

  const getGroupKey = (item) => {
    const raw =
      (groupBy && item?.[groupBy]) ||
      item?.parcelNoWithRecordSerialNo ||
      item?.parcelOderNo ||
      item?.parcelNo;
    if (raw != null && String(raw).trim() !== "") return String(raw).trim();
    return `__row_${item?.id ?? Math.random()}`;
  };

  const groupedList = useMemo(() => {
    if (!groupBy) return null;
    const rows = filteredRows || fetchedData || [];
    const map = new Map();
    rows.forEach((item) => {
      const key = getGroupKey(item);
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(item);
    });
    return Array.from(map.entries()).map(([key, items]) => {
      const sorted = [...items].sort((a, b) => {
        const da = new Date(a?.paymentDate || a?.creationDate || 0).getTime();
        const db = new Date(b?.paymentDate || b?.creationDate || 0).getTime();
        return db - da;
      });
      return { key, items: sorted };
    });
  }, [groupBy, filteredRows, fetchedData]);

  // Fetch parcel cost details
  const fetchParcelCostDetails = (parcelNo) => {
  setCurrentParcelNo(parcelNo);
  setLoadingCostData(true);

  axios
    .get(`${backendUrl}ParcelDetails/GetParcelCostDetails?parcelNo=${parcelNo}`)
    .then((res) => {
      setParcelCostData(res.data);
      setShowCostModal(true);
    })
    .catch((error) => {
      console.error("Error fetching parcel cost details:", error.message);
      // Optional: show toast or alert here
    })
    .finally(() => {
      setLoadingCostData(false);
    });
};


  // Type validation for table cells
   const typeValidation = (field, fetchedObject) => {
    if (
      !fetchedObject[field] &&
      field !== "boxAssignPreviousMonth" &&
      field !== "limitCurrentMonth" &&
      field !== "boxAssignCurrentMonth" &&
      field !== "limitPreviousMonth" &&
      field !== "isAgent" &&
      field !== "boxQty" &&
      field !== "isHub" &&
      field !== "isOffice" &&
      field !== "isActive" &&
      field !== "isExpressService" &&
      field !== "receiveQty" &&
      field !== "adjustmentQty" &&
      field !== "Route Cost" &&
      field !== "Dimension Cost" && //
      field !== "Weight Cost" &&
      field !== "Item Type Cost" &&
      field !== "Additional Cost" &&
      field !== "Cargo Type Cost" &&
      field !== "Extra Packaging Cost" &&
      field !== "Pickup Cost" &&
      field !== "Total" && //
      field !== "issueQty"
    ) {
      return <span className="text-red-400">Not Available</span>;
    }

    if (field === "isActive" && fetchedObject[field] === true) return "Active";
    if (field === "isActive" && fetchedObject[field] === false)
      return "Inactive";

    if (
      (field === "isExpressService" ||
        field === "isHub" ||
        field === "isOffice" ||
        field === "isAgent") &&
      fetchedObject[field] === true
    )
      return "Yes";
    if (
      (field === "isExpressService" ||
        field === "isHub" ||
        field === "isOffice" ||
        field === "isAgent") &&
      fetchedObject[field] === false
    )
      return "No";

    if (field === "parcelStatusId") {
      let data = parcelStatus?.find(
        (item) => item.id === fetchedObject[field]
      )?.parcelStatusName;

      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "scanningPersonId") {
      let data = scanningPerson?.find(
        (item) => item.userId === fetchedObject[field]
      )?.userName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "scanningPointId") {
      let data = scanningPoint?.find(
        (item) => item.id === fetchedObject[field]
      )?.scanningPointName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "measurementUnitId") {
      let data = measurementUnit?.find(
        (item) => item.id === fetchedObject[field]
      )?.unitDescription;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "deviceId") {
      let data = device?.find(
        (item) => item.id === fetchedObject[field]
      )?.deviceName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "dimensionId") {
      // Try dimensions first (new state), fallback to boxName for backward compatibility
      let data = dimensions?.find(
        (item) => item.id === fetchedObject[field]
      )?.dimensionName || boxName?.find(
        (item) => item.id === fetchedObject[field]
      )?.dimensionName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "dimensionName") {
      // Direct dimensionName field from API response
      return fetchedObject[field] || <span className="text-red-400">Not Available</span>;
    }
    if (field === "agentId" || field === "transportAgentId") {
      let data = agent?.find((item) => item.id === fetchedObject[field])?.name;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "companyId") {
      let data = companys?.find(
        (item) => item.id === fetchedObject[field]
      )?.name;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "routeId") {
      let data = routes?.find(
        (item) => item.id === fetchedObject[field]
      )?.routeName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "cargoId") {
      let data = cargoTypes?.find(
        (item) => item.id === fetchedObject[field]
      )?.cargoTypeName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "MeasurementUnitId") {
      // need to update.
      let data = measurementUnits?.find(
        (item) => item.id === fetchedObject[field]
      )?.cargoTypeName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "issuedBy") {
      // need to update.
      let data = allUser?.find(
        (item) => item.id === fetchedObject[field]
      )?.roleName;

      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (
      field === "startDate" ||
      field === "paymentDate" ||
      field === "issueDate" ||
      field === "transactionDate"
    ) {
      const date = new Date(fetchedObject[field]);

      let data = `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()}`;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "endDate") {
      const date = new Date(fetchedObject[field]);
      let data = `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()}`;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "discountedDate") {
      const date = new Date(fetchedObject[field]);
      let data = `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()}`;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }

    return fetchedObject[field];
  };

  // Pagination logic
  const limit = 10;

  const getbuttonNumbersArray = (start, end) => {
    const numbersArray = [];
    for (let i = start; i <= end; i++) {
      numbersArray.push(i);
    }
    return numbersArray;
  };

  const sourceRowCount = groupBy
    ? groupedList?.length || 0
    : (filteredRows || fetchedData)?.length || 0;

  const splitData = (page) => {
    const startingIndex = (page - 1) * limit;
    const endingIndex = page * limit;

    if (groupBy) {
      setPageGroups((groupedList || []).slice(startingIndex, endingIndex));
      return;
    }

    const rows = filteredRows || fetchedData || [];
    setData(rows.slice(startingIndex, endingIndex));
  };

  useEffect(() => {
    splitData(pageNo);
  }, [pageNo, fetchedData, filteredRows, groupBy, groupedList]);

  const totalPaginationPage = Math.ceil(sourceRowCount / limit) || 1;

  useEffect(() => {
    if (totalPaginationPage < 4)
      return setPaginationButtonNumbers(
        getbuttonNumbersArray(1, totalPaginationPage)
      );
    return setPaginationButtonNumbers(getbuttonNumbersArray(1, 4));
  }, [fetchedData, filteredRows, reArange, totalPaginationPage, groupBy]);

  const skipPaginationNumber = (start, end) => {
    setPaginationButtonNumbers(getbuttonNumbersArray(start, end));
  };

  // Table search handler
  const TableSearchHandle = (e) => {
    e.preventDefault();
    const searchAbleText = e.target.searchText.value;
    if (!fetchedData) return;

    const isInclued = (values) => {
      for (let item of values) {
        if (item !== null && item !== undefined) {
          const preferedItem = item.toString().toLowerCase();
          const preferedSearchText = searchAbleText.toString().toLowerCase();
          if (preferedItem.includes(preferedSearchText)) return true;
        }
      }
      return false;
    };

    const nextFiltered = fetchedData.filter((item) => {
      const itemValuesArray = Object.values(item);
      return isInclued(itemValuesArray);
    });

    setFilteredRows(nextFiltered);
    setPageNo(1);
    setExpandedGroupKey(null);
  };

  // Clear search
  const clearSearch = () => {
    setFilteredRows(fetchedData);
    setPageNo(1);
    setSearchText("");
    setExpandedGroupKey(null);
  };

  const buildEditFuncData = (fetchedObject) => {
    const editFuncData = {
      id: fetchedObject?.id,
      modificationDate: new Date(),
    };
    extraFields?.forEach(
      (field) => (editFuncData[field] = fetchedObject[field]),
    );
    row?.forEach((field) => {
      editFuncData[field] = fetchedObject[field];
    });
    return editFuncData;
  };

  const renderPaymentCells = (fetchedObject) =>
    row?.map((field, idx) => (
      <td
        key={idx}
        className="text-center text-sm lg:text-base font-normal lg:font-semibold lg:py-3 py-2 px-4 max-w-[14rem]"
        onClick={() => {
          if (onSelectCallBack) {
            onSelectCallBack(fetchedObject);
          }
        }}
        style={{
          cursor: onSelectCallBack ? "pointer" : "default",
        }}
      >
        <span className="inline-block max-w-full break-words">
          {typeValidation(field, fetchedObject)}
        </span>
      </td>
    ));

  const renderActionCell = (fetchedObject, rowIndex) => (
    <td className="text-center py-2 px-3">
      <div className="flex justify-center items-center gap-2">
        {!hideEdit && (
          <>
            <button
              type="button"
              className="text-center py-2 font-semibold flex justify-center items-center text-xl text-stone-600 hover:text-stone-900"
              onClick={(e) => {
                e.stopPropagation();
                editCallBack(buildEditFuncData(fetchedObject));
                setActiveRow(rowIndex);
              }}
            >
              <FiEdit />
            </button>

            <button
              type="button"
              className="text-center py-2 font-semibold flex justify-center items-center text-xl text-stone-600 hover:text-stone-900"
              onClick={(e) => {
                e.stopPropagation();
                setActiveRow(rowIndex);
              }}
            >
              <MdPreview />
            </button>
          </>
        )}
        {showViewCost && fetchedObject.parcelNo && (
          <button
            type="button"
            className="text-center py-2 font-semibold flex justify-center items-center text-xl text-blue-600"
            onClick={(e) => {
              e.stopPropagation();
              fetchParcelCostDetails(fetchedObject.parcelNo);
            }}
            disabled={
              loadingCostData && currentParcelNo === fetchedObject.parcelNo
            }
          >
            {loadingCostData && currentParcelNo === fetchedObject.parcelNo
              ? "Loading..."
              : "View Cost"}
          </button>
        )}
      </div>
    </td>
  );

  const tableColSpan =
    (notSearchAble ? 0 : 1) +
    (headers?.length || 0) +
    (!notSearchAble && !notEditAble ? 1 : 0);

  const fieldLabel = (field) => {
    const idx = row?.indexOf(field);
    if (idx != null && idx >= 0 && headers?.[idx]) return headers[idx];
    return field;
  };

  return (
    <div className={small ? "scale-95 text-end" : "text-end"}>
      {!notSearchAble && (
        <form
          onSubmit={TableSearchHandle}
          className={
            noSearch
              ? "hidden"
              : "inline-flex flex-wrap items-center gap-2 justify-end mb-3"
          }
        >
          <input
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
            required
            className="w-[220px] max-w-full min-w-0 border border-stone-300 pl-3 h-9 outline-none rounded-lg bg-stone-50"
            type="text"
            name="searchText"
            placeholder="Search..."
          />
          <button
            className="font-medium text-sm bg-stone-800 rounded-lg h-9 px-3 text-white"
          >
            Search
          </button>
          <button
            onClick={clearSearch}
            type="button"
            className="font-medium text-sm bg-stone-800 rounded-lg h-9 px-3 text-white"
          >
            Clear
          </button>
        </form>
      )}
      <div className={`w-full overflow-x-auto ${groupBy ? "payment-history-table-wrap" : "rounded-lg overflow-hidden border border-stone-200"}`}>
        <div className="min-w-0">
          <table
            className={`w-full ${groupBy ? "payment-history-table min-w-[560px]" : ""}`}
          >
            <thead className="">
              {groupBy ? (
                <tr className="payment-history-head">
                  <th className="w-12">#</th>
                  <th className="text-left">Parcel</th>
                  <th className="text-left">Payments</th>
                  <th className="text-right">Total</th>
                  <th className="w-24 text-center">Action</th>
                </tr>
              ) : (
                <tr className="w-full bg-stone-100 text-[11px] font-semibold uppercase tracking-wide text-stone-500 text-center">
                  {!notSearchAble && (
                    <th className="py-2 px-3 w-12">S/N</th>
                  )}
                  {headers?.map((item) => (
                    <th
                      key={item}
                      className="py-2 px-3 text-[11px] font-semibold"
                    >
                      <span className="inline-block break-words">
                        {formateText(item)}
                      </span>
                    </th>
                  ))}
                  {!notSearchAble && (
                    <th
                      className={
                        notEditAble ? "hidden" : "py-2 px-3 w-20"
                      }
                    >
                      Action
                    </th>
                  )}
                </tr>
              )}
            </thead>
            <tbody>
              {isAllDataFetched &&
                groupBy &&
                pageGroups?.map((group, groupIndex) => {
                  const isExpanded = expandedGroupKey === group.key;
                  const latest = group.items[0];
                  const totalAmount = group.items.reduce(
                    (sum, payment) =>
                      sum + (Number(payment?.orderAmount) || 0),
                    0,
                  );
                  const symbol =
                    latest?.symbol ||
                    latest?.currencyType ||
                    group.items.find((p) => p?.symbol || p?.currencyType)
                      ?.symbol ||
                    group.items.find((p) => p?.currencyType)?.currencyType ||
                    "GBP";
                  const statusSummary = summarizeGroupStatuses(group.items);
                  const parcelLabel = group.key.startsWith("__row_")
                    ? "Unknown parcel"
                    : group.key;
                  const parcelIdPart = parcelLabel.includes("~")
                    ? parcelLabel.split("~")[0]
                    : parcelLabel;
                  const serialPart = parcelLabel.includes("~")
                    ? parcelLabel.split("~").slice(1).join("~")
                    : "";

                  return (
                    <React.Fragment key={group.key}>
                      <tr
                        className={`payment-history-group-row ${
                          isExpanded ? "payment-history-group-row--open" : ""
                        }`}
                        onClick={() =>
                          setExpandedGroupKey((prev) =>
                            prev === group.key ? null : group.key,
                          )
                        }
                        aria-expanded={isExpanded}
                      >
                        <td className="payment-history-cell-center text-stone-500 font-semibold">
                          {(pageNo - 1) * limit + (groupIndex + 1)}
                        </td>
                        <td className="payment-history-cell-left">
                          <span className="inline-flex items-start gap-2 max-w-full">
                            <span
                              className={`mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-white border border-stone-200 text-stone-600 transition-transform ${
                                isExpanded ? "rotate-180" : ""
                              }`}
                            >
                              <FiChevronDown size={14} />
                            </span>
                            <span className="min-w-0">
                              <span className="block font-semibold text-stone-900 break-all">
                                {serialPart || parcelLabel}
                              </span>
                              {serialPart ? (
                                <span className="block text-xs text-stone-500 mt-0.5">
                                  Parcel #{parcelIdPart}
                                </span>
                              ) : null}
                            </span>
                          </span>
                        </td>
                        <td className="payment-history-cell-left">
                          <span className="inline-flex flex-wrap items-center gap-2">
                            <span className="payment-history-count">
                              {group.items.length}
                            </span>
                            <span className="text-xs sm:text-sm text-stone-600 font-medium">
                              {statusSummary}
                            </span>
                          </span>
                        </td>
                        <td className="payment-history-cell-right font-bold text-stone-900 whitespace-nowrap">
                          {formatCurrency(totalAmount, symbol)}
                        </td>
                        <td className="payment-history-cell-center">
                          <span className="payment-history-toggle">
                            {isExpanded ? "Hide" : "View"}
                          </span>
                        </td>
                      </tr>

                      {isExpanded && (
                        <tr className="payment-history-expand-row">
                          <td colSpan={5} className="p-0">
                            <div className="payment-history-detail-wrap">
                              <table className="payment-history-detail-table">
                                <thead>
                                  <tr>
                                    <th>S/N</th>
                                    <th>Payment Date</th>
                                    <th>Parcel Order Number</th>
                                    <th>Order Amount</th>
                                    <th>Currency Type</th>
                                    <th>Description</th>
                                    <th>Payment Method</th>
                                    <th>Payment Status</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {group.items.map((item, itemIndex) => {
                                    const rowKey = `${group.key}-${
                                      item?.id ?? itemIndex
                                    }`;
                                    const tone = paymentStatusTone(
                                      item?.statusName,
                                      item?.paymentStatusId,
                                    );
                                    const invoiceNo = String(
                                      item?.paymentInvoiceNo || "",
                                    ).trim();
                                    const canInvoice =
                                      /^inv/i.test(invoiceNo) ||
                                      invoiceNo.length >= 6;
                                    const amount =
                                      Number(item?.orderAmount) || 0;
                                    const itemSymbol =
                                      item?.symbol ||
                                      item?.currencyType ||
                                      symbol;
                                    const paidOn = formatPaymentDate(
                                      item?.paymentDate,
                                    );
                                    const busy =
                                      invoiceBusyKey != null &&
                                      String(invoiceBusyKey) ===
                                        String(item?.id ?? rowKey);
                                    const desc = String(
                                      item?.description || "",
                                    ).trim();
                                    const parcelNo =
                                      item?.parcelNoWithRecordSerialNo ||
                                      group.key;

                                    return (
                                      <tr
                                        key={rowKey}
                                        className={
                                          activeRow === rowKey
                                            ? "payment-history-detail-row--active"
                                            : ""
                                        }
                                      >
                                        <td className="text-center font-semibold text-stone-600">
                                          {itemIndex + 1}
                                        </td>
                                        <td className="text-center whitespace-nowrap">
                                          {paidOn || (
                                            <span className="text-stone-400">
                                              —
                                            </span>
                                          )}
                                        </td>
                                        <td className="text-center break-all">
                                          {parcelNo}
                                        </td>
                                        <td className="text-center font-semibold whitespace-nowrap">
                                          {formatCurrency(amount, itemSymbol)}
                                        </td>
                                        <td className="text-center">
                                          {item?.currencyType ||
                                            item?.symbol ||
                                            "—"}
                                        </td>
                                        <td
                                          className="text-left max-w-[14rem]"
                                          title={desc || undefined}
                                        >
                                          <span className="line-clamp-2 break-words">
                                            {desc || (
                                              <span className="text-stone-400">
                                                —
                                              </span>
                                            )}
                                          </span>
                                        </td>
                                        <td className="text-center">
                                          {item?.paymentMethodName || (
                                            <span className="text-stone-400">
                                              —
                                            </span>
                                          )}
                                        </td>
                                        <td className="text-center">
                                          <span
                                            className={`payment-history-status ${tone.chip}`}
                                          >
                                            {item?.statusName || "—"}
                                          </span>
                                        </td>
                                        <td className="text-center">
                                          <div className="payment-history-line-actions justify-center">
                                            {!hideEdit && (
                                              <button
                                                type="button"
                                                className="payment-history-icon-btn"
                                                title="Edit"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  editCallBack?.(
                                                    buildEditFuncData(item),
                                                  );
                                                  setActiveRow(rowKey);
                                                }}
                                              >
                                                <FiEdit size={14} />
                                              </button>
                                            )}
                                            {onPrintInvoice ? (
                                              <button
                                                type="button"
                                                className="payment-history-icon-btn"
                                                disabled={!canInvoice || busy}
                                                title={
                                                  canInvoice
                                                    ? "Print invoice"
                                                    : "No invoice to print"
                                                }
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  onPrintInvoice(item);
                                                }}
                                              >
                                                <FiPrinter size={14} />
                                              </button>
                                            ) : null}
                                            {onDownloadInvoice ? (
                                              <button
                                                type="button"
                                                className="payment-history-icon-btn payment-history-icon-btn--primary"
                                                disabled={!canInvoice || busy}
                                                title={
                                                  canInvoice
                                                    ? "Download invoice"
                                                    : "No invoice to download"
                                                }
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  onDownloadInvoice(item);
                                                }}
                                              >
                                                <FiDownload size={14} />
                                              </button>
                                            ) : null}
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}

              {isAllDataFetched &&
                !groupBy &&
                data?.map((item, index) => {
                  const fetchedObject = item;

                  return (
                    <tr
                      key={item?.id ?? index}
                      className={
                        activeRow === index
                          ? "bg-orange-50"
                          : index % 2 !== 0
                          ? "bg-stone-50"
                          : "bg-white"
                      }
                    >
                      {!notSearchAble && (
                        <td className="text-center lg:py-3 py-2 font-normal lg:font-semibold">
                          {(pageNo - 1) * limit + (index + 1)}
                        </td>
                      )}

                      {renderPaymentCells(fetchedObject)}
                      {renderActionCell(fetchedObject, index)}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination controls */}
      <div
        className={
          sourceRowCount <= limit
            ? "hidden"
            : "flex flex-wrap items-center gap-1.5 m-auto justify-center mt-4"
        }
      >
        <button
          onClick={() => {
            if (
              pageNo === PaginationButtonNumbers[0] &&
              (pageNo < totalPaginationPage) & (pageNo > 1)
            ) {
              if (totalPaginationPage >= pageNo - 4 && pageNo - 4 >= 1)
                skipPaginationNumber(pageNo - 4, pageNo);
              else if (1 > pageNo - 4) skipPaginationNumber(1, pageNo);
            }
            if (1 < pageNo) {
              setPageNo((prev) => prev - 1);
            }
          }}
          className="font-medium text-sm bg-stone-900 rounded-lg px-3 py-2 text-white"
        >
          <MdOutlineArrowBackIosNew className="lg:text-xl text-sm" />
        </button>

        <button
          onClick={() => {
            if ((pageNo <= totalPaginationPage) & (pageNo > 1)) {
              if (totalPaginationPage >= pageNo - 4 && pageNo - 4 >= 1) {
                skipPaginationNumber(pageNo - 4, pageNo);
                setPageNo((prev) => prev - 4);
              } else if (1 > pageNo - 4) {
                skipPaginationNumber(1, pageNo);
                setPageNo((prev) => prev - (pageNo - 1));
              }
            }
          }}
          className={
            "font-medium  text-2xl  rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-black"
          }
        >
          ...
        </button>

        {PaginationButtonNumbers?.map((item) => {
          return (
            <button
              onClick={() => setPageNo(item)}
              className={`font-medium text-sm rounded-lg px-3 py-2 ${
                pageNo === item
                  ? "bg-orange-600 text-white"
                  : "bg-stone-900 text-white"
              }`}
              key={item}
            >
              {item}
            </button>
          );
        })}

        <button
          onClick={() => {
            if (pageNo < totalPaginationPage) {
              if (totalPaginationPage >= pageNo + 4) {
                skipPaginationNumber(pageNo, pageNo + 4);
                setPageNo((prev) => prev + 4);
              } else if (totalPaginationPage < pageNo + 4) {
                skipPaginationNumber(pageNo, totalPaginationPage);
                setPageNo((prev) => prev + totalPaginationPage - pageNo);
              }
            }
          }}
          className={
            "font-medium  text-2xl  rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-black"
          }
        >
          ...
        </button>
        <button
          onClick={() => {
            if (
              pageNo ===
                PaginationButtonNumbers[PaginationButtonNumbers.length - 1] &&
              pageNo < totalPaginationPage
            ) {
              if (totalPaginationPage >= pageNo + 4)
                skipPaginationNumber(pageNo, pageNo + 4);
              else if (totalPaginationPage < pageNo + 4)
                skipPaginationNumber(pageNo, totalPaginationPage);
            }
            if (totalPaginationPage > pageNo) {
              setPageNo((prev) => prev + 1);
            }
          }}
          className="font-medium text-sm bg-stone-900 rounded-lg px-3 py-2 text-white"
        >
          <MdOutlineArrowForwardIos className="lg:text-xl text-sm" />
        </button>
      </div>

      {/* Parcel Cost Details Modal */}
      {showCostModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Parcel Cost Details</h2>
              <button
                onClick={() => setShowCostModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {loadingCostData ? (
              <div className="flex justify-center items-center h-32">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
              </div>
            ) : (
              <>
                <div className="mb-6">
                  <h3 className="text-lg font-semibold mb-2">
                    Parcel Number: {currentParcelNo}
                  </h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-700 mb-2">Base Costs</h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Sub Total:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.subTotal || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>VAT Tax Amount:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.vaT_TaxAmount || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-700 mb-2">Service Costs</h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Route Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.routeCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Shipping Service:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.shippingServiceAmount || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Pick Up Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.pickUpCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-700 mb-2">Item Costs</h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Item Type Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.itemTypeCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Weight Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.weightCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Dimension Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.dimensionCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Cargo Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.cargoCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-700 mb-2">Adjustments</h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Discount Amount:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.discountAmount || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Extra Packaging:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.extraPackagingCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 p-4 rounded-lg">
                  <div className="flex justify-between items-center">
                    <h4 className="font-bold text-lg">Total Amount:</h4>
                    <span className="text-xl font-bold">
                      {formatCurrency(
                        (parcelCostData?.subTotal || 0) +
                          (parcelCostData?.vaT_TaxAmount || 0),
                        parcelCostData?.symbol || "GBP",
                      )}
                    </span>
                  </div>
                </div>
              </>
            )}

            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setShowCostModal(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HistoryTable;